@if (!isLoading && (!productErrorMode || !products.length)) {
  <svg
    viewBox="0 0 960 540"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    class="min-h-screen min-w-screen fixed left-0"
    style="bottom: -10rem"
  >
    <rect x="0" y="0" width="960" height="540" fill="var(--surface-ground)"></rect>
    <path
      d="M0 331L26.7 321C53.3 311 106.7 291 160 291C213.3 291 266.7 311 320 329.5C373.3 348 426.7 365 480 373.2C533.3 381.3 586.7 380.7 640 373.8C693.3 367 746.7 354 800 341.2C853.3 328.3 906.7 315.7 933.3 309.3L960 303L960 541L933.3 541C906.7 541 853.3 541 800 541C746.7 541 693.3 541 640 541C586.7 541 533.3 541 480 541C426.7 541 373.3 541 320 541C266.7 541 213.3 541 160 541C106.7 541 53.3 541 26.7 541L0 541Z"
      fill="var(--primary-color)"
    ></path>
  </svg>
}

<div
  class="px-5 flex flex-column justify-content-center align-items-center"
  [ngClass]="{
    'min-h-screen': !productErrorMode || !products.length,
    'pt-3': productErrorMode && products.length
  }"
>
  <div class="z-1 text-center">
    <div class="text-900 font-bold text-2xl md:text-8xl mb-2">Oops!</div>
    <p class="line-height-3 mt-0 mb-2 text-700 text-xl font-medium">
      {{ !productErrorMode ? 'There is nothing here' : 'Product Not Found' }}
    </p>
    <app-button
      [linkTo]="!productErrorMode ? '/' : 'products'"
      [label]="!productErrorMode ? 'Go To Home' : 'Go To Products'"
      class="font-medium p-button-raised"
    ></app-button>
  </div>
  @if (productErrorMode && products.length) {
    <div class="inner-container product-list">
      <div class="card">
        <div class="grid">
          <div class="col-12">
            <h2 class="text-sm md:text-2xl font-semibold text-800 text-center mb-1">
              Check out these similar products
            </h2>
            <p class="text-xs md:text-base text-600 text-center">
              You might find what you're looking for
            </p>
          </div>
          @if (isLoading) {
            @for (skeleton of skeletons; track skeleton) {
              <div class="col-6 md:col-4">
                <div class="product">
                  <div class="mb-3 product-container">
                    <div class="product-price-container">
                      <p-skeleton width="50px" height="16px" borderRadius="12px"></p-skeleton>
                    </div>

                    <div class="image-skeleton">
                      <p-skeleton width="100%" height="208px"></p-skeleton>
                    </div>

                    <div class="flex flex-column align-items-center mt-3">
                      <p-skeleton width="115px" height="16px"></p-skeleton>
                      <p-skeleton width="135px" height="16px"></p-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            }
          } @else {
            @for (product of products; track product.id) {
              <div class="col-6 md:col-4 lg:col-4">
                <app-product-item [product]="product"></app-product-item>
              </div>
            } @empty {
              <div class="no-products">
                <p class="text-center text-lg text-500">
                  No products available at the moment. Please check back later!
                </p>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
